import React, { KeyboardEvent, memo } from "react";

// Style
import "./GoTo.scss";

// Classes
import clsx from "clsx";

// Components
import FieldText from "components/UiKit/FieldText";

// Type
type TGoTo = {
  style?: {},
  value?: number,
  name?: string,
  isWhite?: boolean,
  disabled?: boolean,
  className?: string,
  onKeyPress?: any,
  handlerChange?: any,
  classNameLabel?: string,
}

// Component
const GoTo: React.FC<TGoTo> = memo((props) => {
  const {
    name,
    value,
    style,
    isWhite,
    disabled,
    className,
    onKeyPress,
    handlerChange,
    classNameLabel
  } = props;

  const handlerOnKeyPress = (e: KeyboardEvent<HTMLImageElement>) => {
    if (e.key === "Enter") {
      if (onKeyPress) {
        onKeyPress(e);
      }
      e.preventDefault();
    }
  };

  const cn = clsx(
    "go-to flex flex-ai-center",
    className ? className : "",
    isWhite ? "go-to__white" : "",
    disabled ? "go-to__disabled" : ""
  );

  const cnLabel = clsx(
    "go-to__label",
    classNameLabel ? classNameLabel : ""
  );

  return (
    <div className={cn}>
      <p className={cnLabel}>Go To: </p>
      <FieldText
        name={name}
        value={value}
        style={style}
        pattern="[0-9]+"
        disabled={disabled}
        innerTypeInput="number"
        onChange={handlerChange}
        className="go-to__input"
        onKeyPress={handlerOnKeyPress}
      />
    </div>
  );
});

export default GoTo;
